const fares = {
  toast: {
    error: {
      badResponse: '[Fare] schlechte Serverantwort',
      create: {},
      edit: {},
    },
    success: {
      create: {
        default: '[Tarif] Erfolgreich erstellt',
      },
      edit: {},
      delete: {
        default: '[Tarif] erfolgreich gelöscht',
      },
    },
  },
  createFareBtn: 'Erstellen',
  showBreakdownBtn: 'Breakdown anzeigen',
  total: 'Total: ',

  deleteModal: {
    header: 'Tarife löschen',
    body: 'Sie sind dabei, {{num}} Tarife zu löschen.',
  },

  table: {
    headers: {
      biDir: 'Bidirektional',
    },
    biDirOptions: {
      way2: '2-Wege',
      way1: '1-Weg',
    },
    actions: {
      delete: 'Löschen',
      export: 'Exportieren',
    },
  },

  fareTypeOptions: {
    Base: 'Basis',
    Addition: 'Zusatz',
    Percent: 'Prozent',
    Total: 'Gesamt',
  },

  additions: {
    value: 'Wert',
    valueType: 'Werttyp',
    name: 'Name',
    hour1: 'Startzeit',
    hour2: 'Endzeit',
    date1: 'Startdatum',
    date2: 'Enddatum',
    cancel: 'Stornieren',
    addAddition: 'Zusatz hinzufügen',
    priority: 'Priorität',
    weekDays: 'Wochentage',
    newAddition: 'Neuer Zusatz',
    price: 'Preis',
    total: 'Gesamt',
    percent: 'Prozent',
    columnExist: 'Titel existiert bereits',
  },

  create: {
    confirmButtonText: 'Bestätigen',
    code: 'Code',
    from: 'Von',
    to: 'Bis',
    service: 'Leistungen',
    select: 'Wählen',
    validations: {
      code: 'Code ist erforderlich',
    },

    successToast: {
      message: 'Erfolg! Tarif erstellt.',
    },
    errorToast: {
      message: 'Es ist ein Fehler aufgetreten! Der Tarif konnte nicht erstellt werden.',
    },
  },

  update: {
    code: 'Code',
    from: 'Von',
    to: 'Bis',
    service: 'Leistungen',
    price: 'Preis',
    confirmButtonText: 'Aktualisieren',
    successMsg: 'Tarif erfolgreich aktualisiert',

    successToast: {
      message: 'Erfolg! Tarif erfolgreich aktualisiert.',
    },
    errorToast: {
      message: 'Fehler aufgetreten! Tarif konnte nicht aktualisiert werden',
    },
  },

  validations: {
    code: {
      require: 'Code ist erforderlich',
    },
    from: {
      require: 'Von ist erforderlich',
    },
    to: {
      require: 'Bis ist erforderlich',
    },
    service: {
      require: 'Service ist erforderlich',
    },
    unit: {
      require: 'Einheit ist erforderlich',
    },
    rateType: {
      require: 'Tariftyp ist erforderlich',
    },
  },
  forms: {
    header: {
      createFare: {
        title: 'Erstellen',
      },

      updateFare: {
        title: 'Aktualisieren',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Einreichen',
        update: 'Einreichen',
      },
    },

    information: {
      details: {
        header: 'Tarifdetails',
        fields: {
          units: {
            name: 'Bereiche',
          },
          name: {
            name: 'Name',
          },
          group: {
            name: 'Gruppe',
          },
          services: {
            name: 'Leistungen',
          },
          biDirectional: {
            name: 'Richtungsabhängig',
          },
          from: {
            name: 'Von Zone',
          },
          to: {
            name: 'Zur Zone',
          },
        },
      },
      mileage: {
        header: 'Kilometerstand',
        fields: {
          distanceFrom: {
            name: 'Entfernung von',
          },
          distanceTo: {
            name: 'Entfernung zu',
          },
        },
      },
      conditions: {
        header: 'Bedingungen',
        fields: {
          startDate: {
            name: 'Startdatum',
          },
          endDate: {
            name: 'Enddatum',
          },
          startHour: {
            name: 'Startzeit',
          },
          endHour: {
            name: 'Endzeit',
          },
          weekDays: {
            name: 'Wochentage',
          },
          fromDate: {
            name: 'Von Datum',
          },
          toDate: {
            name: 'Bis Datum',
          },
        },
      },
    },
  },
};

export default fares;
